import Button from "components/button";
import LoaderButton from "components/button/LoaderButton";
import InputField from "components/fields/InputField";
import Modal from "components/modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { editUsers } from "store/userSlice";
import { useEffect } from "react";
import { editProfile } from "store/userSlice";

function UpdateProfile({ isOpen, setIsOpen }) {
  const dispatch = useDispatch();
  const { editLoading } = useSelector((state) => state.users);
  const { userInfo } = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      firstname: "",
      lastname: "",
      email: "",
      mobile: "",
    },
    mode: "onBlur",
  });

  // 🔹 Reset form values when modal opens or userInfo changes
  useEffect(() => {
    if (userInfo && isOpen) {
      reset({
        firstname: userInfo.firstname || "",
        lastname: userInfo.lastname || "",
        email: userInfo.email || "",
        mobile: userInfo.mobile || "",
      });
    }
  }, [userInfo, isOpen, reset]);

  const closeModal = () => {
    reset();
    setIsOpen(false);
  };

  const onSubmit = async (data) => {
    try {
      const response = await dispatch(
        editProfile({ _id: userInfo._id, ...data })
      );
      if (
        response?.payload?.statuscode === 200 ||
        response?.payload?.statuscode === 201
      ) {
        closeModal();
      } else {
        console.error("Update failed:", response?.msg || "Unknown error");
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  return (
    <div>
      <Modal isOpen={isOpen} onClose={closeModal} className="max-w-4xl">
        <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
          Update Profile
        </h2>

        <div className="mt-5 w-full max-w-4xl flex-col items-center lg:pl-0">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="mx-auto grid w-full grid-cols-1 gap-4"
            noValidate
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <InputField
                id="firstname"
                variant="auth"
                label="Firstname*"
                placeholder="Enter firstname"
                type="text"
                error={errors.firstname}
                {...register("firstname", {
                  required: "Firstname is required",
                })}
              />

              <InputField
                id="lastname"
                variant="auth"
                label="Lastname*"
                placeholder="Enter lastname"
                type="text"
                error={errors.lastname}
                {...register("lastname", { required: "Lastname is required" })}
              />

              <InputField
                id="email"
                variant="auth"
                label="Email*"
                placeholder="mail@simmmple.com"
                type="email"
                autoComplete="email"
                error={errors.email}
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^\S+@\S+$/i,
                    message: "Invalid email address",
                  },
                })}
              />

              <InputField
                id="mobile"
                variant="auth"
                label="Mobile*"
                placeholder="9797979797"
                type="tel"
                autoComplete="tel"
                maxLength={10}
                error={errors.mobile}
                {...register("mobile", {
                  required: "Mobile number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Enter a valid 10-digit number",
                  },
                })}
                onInput={(e) => {
                  e.currentTarget.value = e.currentTarget.value.replace(
                    /[^0-9]/g,
                    ""
                  );
                }}
              />
            </div>

            <div className="flex items-center justify-end gap-2 pt-2">
              <Button type="button" variant="outline" onClick={closeModal}>
                Cancel
              </Button>

              <LoaderButton type="submit" isLoading={editLoading}>
                Update
              </LoaderButton>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
}

export default UpdateProfile;
